
import { Component     } from '@angular/core';
import { ViewChild     } from '@angular/core';
import { ElementRef    } from '@angular/core';
import { HostListener  } from '@angular/core';

import { ConsoleService    } from '@service/console.service';
import { PlatformService   } from '@service/platform.service';
import { FilesystemService } from '@service/filesystem.service';

@Component({
    selector: 'section-perspectives',
    styleUrls: [ 'section-perspectives.template.scss' ],
    templateUrl: 'section-perspectives.template.html'
})
export class SectionPerspectivesComponent {

    public perspectives: any = {
        items: 1,

        nav: true,
        dots: false,
        loop: true,
        navText: ['<', '>'],

        autoplay: false,
        smartSpeed: 1000,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        autoplayMouseleaveTimeout: 10000,

        responsive: {
            0: { items: 1 }
        }
    };

    public tick: number = 0;
    public percent: number = 0;

    public content: any = [];
    public offset: number = 0;
    public animate: boolean = false;

    public slidePosition: number = 1;

    @ViewChild('title')
    public title!: ElementRef;

    @ViewChild('items')
    public items!: ElementRef;

    constructor (private console: ConsoleService,
                 private platform: PlatformService,
                 private filesystem: FilesystemService) {

    }

    ngOnInit () {
        this.console.info('Starting SectionPerspectives');

        let main: any = this.filesystem.readSession('main');
        if (main) {
            this.content = main;
        }

        this.control();
    }

    ngOnDestroy () {
        this.console.info('Destroying SectionPerspectives');
    }

    public controlIt: any = false;
    public control () {
        let state = this.controlIt ? true : false;

        clearInterval(this.controlIt);

        this.controlIt = false;

        if (! state)
            this.controlIt = setInterval(() => {
                this.tick++;
    
                this.percent = this.tick / 25 * 100;
    
                if (this.percent == 100) {
                    (<any> this.items).navigationService.next(1000);
                    this.tick = 0;
                    this.percent = 0;
                }
            }, 500);
    }

    get language () {
        return this.filesystem.readSession('language');
    }

    public translated ($event: any) {
        this.tick = 0;
        this.percent = 0;
        this.slidePosition = $event.startPosition + 1;
    }

    @HostListener('window:scroll', [ '$event' ])
    @HostListener('window:resize', [ '$event' ])
    public animateBySrcoll ($event: any) {
            this.offset = window.scrollY / this.platform.offset(this.title?.nativeElement);
    }

}
